<template>
    <v-card outlined>
        <v-card-text class="d-flex pa-4">
            <v-row>
                <v-col sm="2" class="d-flex align-center justify-center">
                    <div class="text-center">
                        <div>
                            <h2 class="mb-2 mt-1">{{ process.horario }}</h2>
                        </div>
                        <div>
                            <v-chip v-if="process.is_active" label color="primary" x-small>ACTIVO</v-chip>
                            <v-chip v-else label x-small>FINALIZADO</v-chip>
                        </div>
                        <v-chip x-small label outlined>INICIADO: {{ process.created_at | datetime }}</v-chip>
                        <v-chip v-if="process.finished_at" x-small label outlined>FINALIZADO: {{ process.finished_at | datetimeb }}</v-chip>
                    </div>
                </v-col>
                <v-divider vertical inset/>
                <v-col sm="10" cols="d-flex justify-center">
                    <v-simple-table dense>
                        <template slot="default">
                            <thead>
                                <tr>
                                    <th>Provider</th>
                                    <th>Juego</th>
                                    <th>Resultado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(resultado, index) in process.resultado_list" :key="`resultado-item-index-${index}`">
                                    <td>
                                        <v-chip label small color="primary">
                                            <b>{{ resultado.provider_juego.provider.slug }}</b>
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-chip label small color="primary">
                                            <b>{{ resultado.juego.slug }}</b>
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-chip label small>{{ resultado.resultado }}</v-chip>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        process: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
        }
    },
    methods: {
    },
    watch: {
    },
    created() {
    },
}
</script>